import { Instance } from 'mobx-state-tree';
import { PublishingSummaryDtoModelBase } from './PublishingSummaryDtoModel.base';

/* The TypeScript type of an instance of PublishingSummaryDtoModel */
export interface PublishingSummaryDtoModelType extends Instance<typeof PublishingSummaryDtoModel.Type> {}

/* A graphql query fragment builders for PublishingSummaryDtoModel */
export { selectFromPublishingSummaryDto, publishingSummaryDtoModelPrimitives, PublishingSummaryDtoModelSelector } from './PublishingSummaryDtoModel.base';

/**
 * PublishingSummaryDtoModel
 */
export const PublishingSummaryDtoModel = PublishingSummaryDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
